var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91046 2.27832C2.76118 2.27832 2.60508 2.32849 2.49116 2.44224C2.26336 2.67032 2.26336 3.05298 2.49116 3.28107L6.15525 6.94499L2.49116 10.6089C2.26336 10.837 2.26336 11.2196 2.49116 11.4477C2.71901 11.6752 3.10191 11.6752 3.32976 11.4477L6.99379 7.78382L10.6578 11.4477C10.8857 11.6752 11.2686 11.6752 11.4964 11.4477C11.7242 11.2196 11.7242 10.837 11.4964 10.6089L7.83233 6.94499L11.4964 3.28107C11.7242 3.05298 11.7242 2.67032 11.4964 2.44224C11.3825 2.32849 11.2263 2.27832 11.0771 2.27832C10.9278 2.27832 10.7718 2.32849 10.6578 2.44224L6.99379 6.10615L3.32976 2.44224C3.21583 2.32849 3.05973 2.27832 2.91046 2.27832Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelOrderIcon);
export default __webpack_public_path__ + "static/media/cancel_order_icon.6d5aeba634922b14cec321b85c91b67c.svg";
export { ForwardRef as ReactComponent };